<template>
  <VcLoaderOverlay v-if="showLoadingSpinner" class="cart-spinner" />
  <ul v-if="selectedAddr" class="flex max-w-[250px] flex-col font-medium leading-6">
    <!-- Japan-specific address format -->
    <template v-if="selectedAddr.countryCode === 'JPN'">
      <li class="mb-2 font-semibold">{{ selectedAddr.lastName }} {{ selectedAddr.firstName }}</li>
      <li>{{ selectedAddr.postalCode }}</li>
      <li>{{ selectedAddr.regionName }}</li>
      <li>{{ selectedAddr.city }}</li>
      <li>{{ selectedAddr.line1 }}</li>
      <li v-if="selectedAddr.buildingTL">{{ selectedAddr.buildingTL }}</li>
      <li class="mb-2">{{ selectedAddr.phone }}</li>
      <li class="break-all">{{ selectedAddr.email }}</li>
    </template>
    <!-- Other countries format -->
    <template v-else>
      <li v-if="selectedAddr.countryCode === 'CHN'" class="mb-2 font-semibold">
        {{ selectedAddr.lastName }} {{ selectedAddr.firstName }}
      </li>
      <li v-else class="mb-2 font-semibold">{{ selectedAddr.firstName }} {{ selectedAddr.lastName }}</li>
      <li v-if="selectedAddr.organization">{{ selectedAddr.organization }}</li>
      <li v-if="selectedAddr.departmentTL">{{ selectedAddr.departmentTL }}</li>
      <li v-if="selectedAddr.buildingTL || selectedAddr.mailStopTL">
        {{ selectedAddr.buildingTL ?? "" }} {{ selectedAddr.mailStopTL ?? "" }}
      </li>
      <li>{{ selectedAddr.line1 }}</li>
      <li v-if="isMUCCountry(selectedAddr.countryCode!)">
        {{ selectedAddr.regionName || selectedAddr.countyTL }}
        {{ selectedAddr.postalCode }}
        {{ selectedAddr.city }}
      </li>
      <li v-else>
        {{ selectedAddr.city }}, {{ selectedAddr.regionName || selectedAddr.countyTL }}
        {{ selectedAddr.postalCode }}
      </li>
      <li>{{ selectedAddr.countryName }}</li>
      <li class="mb-2">{{ selectedAddr.phone }}</li>
      <li class="break-all">{{ selectedAddr.email }}</li>
      <li v-if="selectedAddr.countryCode === 'IND' && selectedAddr.gstinTL" class="mt-2 break-all">
        <span class="font-semibold">{{ $t("pages.checkout.gstin") }}:</span> {{ selectedAddr.gstinTL }}
      </li>
      <li v-if="selectedAddr.taxExemptNoTL" class="font-medium text-[--color-neutral-a2]">
        Tax Exempt #: {{ selectedAddr.taxExemptNoTL }}
      </li>
    </template>
  </ul>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { isMUCCountry } from "@/core/utilities/address";
import { useCheckoutFacade } from "../../composables/useCheckoutFacade";
const { deliveryAddress: selectedAddr } = useCheckoutFacade();

const showLoadingSpinner = computed(() => {
  return selectedAddr.value === undefined;
});
</script>
